<template>
  <section
    class="latest-news py-14 relative lg:py-28"
    :class="showScribble ? 'bg-white' : 'bg-red-100'"
  >
    <img
      v-if="showScribble"
      src="/frontend/assets/scribble.svg"
      class="hidden lg:block lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:-top-[75px] lg:h-[150px]"
    >

    <img
      src="/frontend/assets/mobile-star.svg"
      class="absolute top-3 left-0 lg:hidden"
    >

    <div class="container">
      <h2 class="text-4xl font-bold text-center lg:text-5xl">
        {{ __('components.latest-news.title') }}
      </h2>
      <p class="mt-6 text-center  text-gray-300 lg:text-xl">
        {{ __('components.latest-news.text') }}
      </p>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4 lg:mt-12 lg:relative">
        <img
          src="/frontend/assets/desktop-star.svg"
          class="hidden lg:block lg:absolute lg:z-10 lg:-left-[90px] lg:-top-[110px]"
        >

        <NewsItem
          v-for="newsItem in newsItems"
          :key="`news-item-${newsItem.slug}`"
          :news="newsItem"
        />

        <img
          src="/frontend/assets/scribble-bottom-desktop.svg"
          class="hidden lg:block lg:absolute lg:-right-[100px] lg:-bottom-[120px]"
        >
      </div>

      <div class="text-center mt-8 lg:mt-16">
        <Link
          :href="localeRoute('frontend.news.index')"
          class="button-black shadow-button-black inline-block "
        >
          {{ __('components.latest-news.see-all') }}
        </Link>
      </div>
    </div>

    <img
      src="/frontend/assets/scribble-bottom.svg"
      class="absolute bottom-10 right-0 lg:hidden"
    >
  </section>
</template>

<script>
import NewsItem from './NewsItem.vue';

export default {
  components: {
    NewsItem,
  },

  props: {
    showScribble: {
      type: Boolean,
      required: false,
      default: false,
    },

    newsItems: {
      type: Array,
      required: true,
    },
  },
};
</script>
